import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getReviewScoreFilterVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {searchParamToFacet} from 'modules/search/constants'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {ReviewScoreBottomSheetContentLoadable} from './Loadable'

const filterKeys = [searchParamToFacet.reviewScore.param]

export const ReviewScoreBottomSheet = () => {
  const dispatch = useDispatch()
  const {formatMessage} = useIntl()
  const {toggleFilters, getFilters, submitFilters, resetFilters, clearFilters} =
    useFiltersForm(filterKeys)

  const {reviewScore} = getFilters()

  const isOpen = useSelector(getReviewScoreFilterVisibility)

  const handleApply = useCallback(() => {
    submitFilters()
  }, [submitFilters])

  const handleClear = () => {
    if (reviewScore) {
      clearFilters()
    } else {
      dispatch(hideOverlay())
    }
  }

  const handleClose = () => {
    dispatch(hideOverlay())
    resetFilters()
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      navBarProps={{
        centerContent: formatMessage(filterMessages.reviewScore)
      }}
      bottomBarContent={
        <Box
          display="flex"
          justifyContent="space-between"
          data-id="reviewScoreBottomSheetButtons"
        >
          <Button
            dataId="clearFiltersButton"
            onClick={handleClear}
            variant="tertiary"
          >
            <FormattedMessageWrapper id="clear" defaultMessage="Clear" />
          </Button>
          <Button dataId="applyFiltersButton" onClick={handleApply}>
            <FormattedMessageWrapper id="apply" defaultMessage="Apply" />
          </Button>
        </Box>
      }
    >
      {isOpen && (
        <ReviewScoreBottomSheetContentLoadable
          reviewScore={reviewScore}
          toggleFilters={toggleFilters}
        />
      )}
    </BottomSheet>
  )
}
